import { render } from "./OtherSettingsForm.vue?vue&type=template&id=b64bad02"
import script from "./OtherSettingsForm.vue?vue&type=script&lang=js"
export * from "./OtherSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__